export const deriveDbNamePreview = (subdomain) =>
  String(subdomain || "")
    .trim()
    .toLowerCase()
    .replace(/-/g, "_");

export const tenantUrl = (subdomain) => {
  if (!subdomain || subdomain === "master") return null;
  if (process.env.NODE_ENV === "production") {
    return `https://${subdomain}.raborisk.ai`;
  }
  return `http://${subdomain}.localhost:3001`;
};

/** Master DB admin panel origin (no tenant subdomain). */
export const masterAdminUrl = () => {
  if (process.env.NODE_ENV === "production") {
    return "https://test.raborisk.ai/admin";
  }
  return "http://localhost:3001/admin";
};

export const buildCrossTenantImpersonationUrl = (subdomain, impersonationToken, returnToken) => {
  const base = tenantUrl(subdomain);
  if (!base || !impersonationToken) return null;
  const params = new URLSearchParams({ impersonation_token: impersonationToken });
  if (returnToken) params.set("return_token", returnToken);
  return `${base}/dashboards?${params.toString()}`;
};

export const buildCrossTenantReturnUrl = (adminToken) => {
  if (!adminToken) return null;
  const base = masterAdminUrl();
  const params = new URLSearchParams({ admin_return_token: adminToken });
  return `${base}?${params.toString()}`;
};
